module.exports = __webpack_public_path__ + "static/media/WINGS-BNB-BUSD.05fbc12c.svg";